"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Group = _interopRequireDefault(require("../Group"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(_ref) {
  var DropdownButton = _ref.DropdownButton,
      DropdownContainer = _ref.DropdownContainer;
  return function (Target) {
    var _class, _temp;

    return (0, _Group["default"])(function (_ref2) {
      var onSelect = _ref2.onSelect,
          selected = _ref2.selected;
      return {
        onSelect: onSelect,
        selected: selected
      };
    })((_temp = _class =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(Dropdown, _PureComponent);

      function Dropdown() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Dropdown);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Dropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "state", {
          layout: undefined,
          focused: false
        });

        _defineProperty(_assertThisInitialized(_this), "onLayout", function (layout) {
          return _this.setState({
            layout: layout
          });
        });

        _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
          return _this.setState({
            focused: true
          }, _this.props.onFocus);
        });

        _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
          return _this.setState({
            focused: false
          }, _this.props.onBlur);
        });

        _defineProperty(_assertThisInitialized(_this), "renderItem", function (node) {
          return _react["default"].cloneElement(node, {
            onSelect: function onSelect() {
              node.props.onSelect();
              if (_this.props.blurOnChange) setTimeout(function () {
                return _this.onBlur();
              }, 0);
            }
          });
        });

        return _this;
      }

      _createClass(Dropdown, [{
        key: "renderButton",
        value: function renderButton() {
          var renderButton = this.props.renderButton;
          if (renderButton) return renderButton(this._buttonProps);
          return _react["default"].createElement(DropdownButton, this._buttonProps, this.label);
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props = this.props,
              children = _this$props.children,
              zIndex = _this$props.zIndex,
              width = _this$props.width,
              style = _this$props.style,
              className = _this$props.className;
          return _react["default"].createElement(Target, {
            zIndex: zIndex,
            width: width,
            style: style,
            className: className,
            ref: function ref(target) {
              return _this2.setState({
                target: target
              });
            },
            focused: this.state.focused
          }, this.renderButton(), _react["default"].createElement(DropdownContainer, this._containerProps, _react["default"].Children.map(children, this.renderItem)));
        }
      }, {
        key: "label",
        get: function get() {
          var _this$props2 = this.props,
              label = _this$props2.label,
              placeholder = _this$props2.placeholder,
              children = _this$props2.children,
              selectedValue = _this$props2.selectedValue;
          if (label) return label;
          var selectedNode = children.find(function (node) {
            return node.props.selected;
          });
          if (selectedValue === undefined || !selectedNode) return placeholder;
          return selectedNode.props.label || selectedNode.props.children;
        }
      }, {
        key: "_buttonProps",
        get: function get() {
          var _this$props3 = this.props,
              buttonProps = _this$props3.buttonProps,
              props = _objectWithoutProperties(_this$props3, ["buttonProps"]);

          var focused = this.state.focused;
          delete props.renderButton;
          delete props.renderItem;
          delete props.onChange;
          delete props.initialValue;
          delete props.style;
          delete props.className;
          return _objectSpread({}, props, {}, buttonProps, {
            focused: focused,
            isPlaceholder: Boolean(!props.label && !props.selectedValue),
            onFocusChange: focused ? this.onBlur : this.onFocus,
            onLayout: this.onLayout
          });
        }
      }, {
        key: "_containerProps",
        get: function get() {
          var _this$props4 = this.props,
              width = _this$props4.width,
              containerProps = _this$props4.containerProps;
          var _this$state = this.state,
              focused = _this$state.focused,
              target = _this$state.target,
              layout = _this$state.layout;
          return _objectSpread({
            width: width
          }, containerProps, {
            focused: focused,
            target: target,
            layout: layout,
            onDropdownBlur: this.onBlur,
            onDropdownFocus: this.onFocus
          });
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props) {
          if (typeof props.focused !== 'undefined') return {
            focused: Boolean(props.focused)
          };
          return null;
        }
      }]);

      return Dropdown;
    }(_react.PureComponent), _defineProperty(_class, "propTypes", _index.propTypes), _defineProperty(_class, "defaultProps", {
      blurOnChange: true,
      height: 'tall',
      containerProps: {},
      buttonProps: {}
    }), _temp));
  };
};

exports["default"] = _default;